import { COLORS, TYPE, SPACE } from '../tokens'
import SectionLabel from '../SectionLabel'

// Section 6: questions the Specialist could not confirm.
// Question-type findings surface here for advisor follow-up.
export default function SpecialistUncertainty({ findings }) {
  const questions = (findings || []).filter(f => f.finding_type === 'question')
  return (
    <section style={{ maxWidth: SPACE.sectionMaxWidth, margin: '0 auto' }}>
      <SectionLabel>Specialist uncertainty · verify before delivery</SectionLabel>
      {questions.length === 0 ? (
        <p style={{ ...TYPE.body, color: COLORS.mutedText }}>
          The Specialist raised no open questions.
        </p>
      ) : (
        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
          {questions.map(f => (
            <li key={f.id} style={{ padding: '16px 0', borderBottom: `1px solid ${COLORS.hairline}` }}>
              <p style={{ ...TYPE.body, color: COLORS.bodyText, margin: '0 0 4px' }}>{f.title}</p>
              {f.detail && (
                <p style={{ ...TYPE.supporting, color: COLORS.mutedText, margin: 0 }}>{f.detail}</p>
              )}
            </li>
          ))}
        </ul>
      )}
    </section>
  )
}
